import {
  type DeepReadonly,
  inject,
  provide,
  type Reactive,
  type Ref,
  type TeleportProps,
} from 'vue';

export type Context = {
  dataTestid?: DeepReadonly<Ref<string | undefined>>;
  registerMenuGroup: (id: symbol) => void;
  deregisterMenuGroup: (id: symbol) => void;
  /**
   * Move focus to the menu trigger button. Called by a menu item before it runs
   * its action so that any dialog opened by the action records the (persistent)
   * trigger — not the menu item, which unmounts when the menu closes — as its
   * focus-restore target. See K10-36133.
   */
  focusTrigger?: () => void;
};

export const MENU_CONTEXT_KEY = Symbol();

export const provideMenuContext = (context: Context) => provide(MENU_CONTEXT_KEY, context);

export const injectMenuContext = () => inject<Context | undefined>(MENU_CONTEXT_KEY, undefined);

type PortalContext = {
  teleportProps: Reactive<TeleportProps>;
};

export const LISTBOX_PORTAL_KEY = Symbol();
export const provideMenuPortalContext = (portalContext: PortalContext) =>
  provide(LISTBOX_PORTAL_KEY, portalContext);
export const injectMenuPortalContext = () =>
  inject<PortalContext | undefined>(LISTBOX_PORTAL_KEY, undefined);
